module.exports = __webpack_public_path__ + "img/stock-logo.324b3cdb.png";